<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-tittle"><span>THE CAZALET FAMILY AND THEIR SERVANTS</span></p>
<p class="fm-03">William Cazalet, known as the Brig</p>
<p class="fm-04">Kitty Barlow, known as the Duchy (his wife)</p>
<p class="fm-05">Rachel, their unmarried daughter</p>
<p class="fm-03">Hugh Cazalet, eldest son</p>
<p class="fm-04">Sybil Carter (his wife)</p>
<p class="fm-05">Polly</p>
<p class="fm-05">Simon</p>
<p class="fm-05">William, known as Wills</p>
<p class="fm-03">Edward Cazalet, second son</p>
<p class="fm-04">Viola, known as Villy (his wife)</p>
<p class="fm-05">Louise</p>
<p class="fm-05">Teddy</p>
<p class="fm-05">Lydia</p>
<p class="fm-03">Rupert Cazalet, third son</p>
<p class="fm-04">Zoë (second wife)</p>
<p class="fm-04">Isobel (first wife; died having Neville)</p>
<p class="fm-05">Clarissa, known as Clary</p>
<p class="fm-05">Neville</p>
<p class="fm-03">Jessica Castle (Villy’s sister)</p>
<p class="fm-04">Raymond (her husband)</p>
<p class="fm-05">Angela</p>
<p class="fm-05">Christopher</p>
<p class="fm-05">Nora</p>
<p class="fm-05">Judy</p>
<p class="fm-03">Mrs Cripps (cook)</p>
<p class="fm-03a">Eileen (parlourmaid)</p>
<p class="fm-03a">Peggy and Bertha (housemaids)</p>
<p class="fm-03a">Dotty (kitchenmaid)</p>
<p class="fm-03a">Tonbridge (chauffeur)</p>
<p class="fm-03a">McAlpine (gardener)</p>
<p class="fm-03a">Wren (groom)</p>
<p class="fm-03a">Billy (gardener’s boy)</p>
<p class="fm-03">Nanny</p>
<p class="fm-03a">Inge (German maid)</p>
<p class="fm-03">Emily (cook)</p>
<p class="fm-03a">Phyllis (parlourmaid)</p>
<p class="fm-03a">Edna (housemaid)</p>
<p class="fm-03a">Nanny</p>
<p class="fm-03a">Edie (daily help in the country)</p>
<p class="fm-03">Ellen (nurse)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter04.vue?b97d09b8